<script lang="ts">
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import InfoBanner from 'shared/ui-widgets/banner/InfoBanner.svelte';
</script>

<KpHeading type="h2">Hospodaření zakázky</KpHeading>

<InfoBanner>
    <svelte:fragment slot="text">
        Tato sekce ještě není implementována.
    </svelte:fragment>
</InfoBanner>